import {
    Component, ElementRef,
    Inject, OnInit,
    ViewChild
} from "@angular/core";
import {
    FormBuilder,
    FormGroup,
    Validators
} from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { GlobalVariable } from "../app.component";
import { DataService, Response } from "../dataService/data.service";
import { CommonService } from "../services/common.service";

@Component({
  selector: "app-business-onboarding",
  templateUrl: "./business-onboarding.component.html",
  styleUrls: ["./business-onboarding.component.scss"],
})
export class BusinessOnboardingComponent implements OnInit {
  private BASE_URL = GlobalVariable;
  images: any;
  registerForm: FormGroup;
  submitted = true;
  emailnotvalid: boolean = true;
  websitenotvalid: boolean = true;
  registerForm2: FormGroup;
  firstSetp: boolean = false;
  createdUserId: string;
  address_as_same: Boolean = true;
  has_manager: Boolean = false;
  business_domain: any;
  address_sec: boolean = false;
  business_detail_form: FormGroup;
  business_address_details_form: FormGroup;
  outlet_detail_form: FormGroup;
  outlet_address_details_form: FormGroup;
  outlet_manager_form: FormGroup;
  business_details_submit: Boolean = true;
  business_address_details_submit: Boolean = true;
  stateList: any;
  cities: any;
  countryList: any;
  business_form_details: any;
  onboarding_stateList: any;
  onboarding_cities: any;
  // products: any = ['Review', 'Appointment'];
  products: any;
  productLoading: boolean;
  outlet_id: any;
  selectedProduct: boolean[];
  product_array: any = [];

  // stateList: Array<any> = [
  //   { name: 'TamilNadu', cities: ['Chennai',] },
  //   { name: 'Karnataka', cities: ['Bangalore'] },
  // ];
  // cities: Array<any>;
  // changeState(count) {
  //   this.cities = this.stateList.find(con => con.name == count).cities;
  // }

  @ViewChild("accessSuccessModal", { static: true })
  accessSuccessModal: ElementRef;
  createdBusinessId: any;
  isExistingOwner: boolean;

  constructor(
    private modalService: NgbModal,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private router: Router,
    private HttpService: DataService,
    private toastrService: ToastrService,
    public formBuilder: FormBuilder,
    private commonservice: CommonService
  ) {}

  ngOnInit() {
    let res: Response;
    this.HttpService.get(this.BASE_URL.BUSINESS_DOMAIN).subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {},
      () => {
        // console.log(res.data);
        this.business_domain = res.data["business_domain"];
      }
    );

    this.getZceppaProducts();
    // this.onboardingStateList();
    this.getCountryList();

    /** Business details form */
    this.business_detail_form = this.formBuilder.group({
      firstName: ["", Validators.compose([Validators.required])],
      lastName: ["", Validators.compose([Validators.required])],
      ownerPhone: ["", Validators.compose([Validators.required])],
      ownerEmail: ["", Validators.compose([Validators.required])],
      businessName: ["", Validators.compose([Validators.required])],
      businessAlias: [""],
      businessDomain: ["", Validators.compose([Validators.required])],
      businessWebsite: [""],
    });
    /** Business address details form */
    this.business_address_details_form = this.formBuilder.group({
      addressLine1: ["", Validators.compose([Validators.required])],
      addressLine2: ["", Validators.compose([Validators.required])],
      businessCity: ["", Validators.compose([Validators.required])],
      businessState: ["", Validators.compose([Validators.required])],
      businessCountry: ["", Validators.compose([Validators.required])],
      pincode: ["", Validators.compose([Validators.required])],
      businessDescription: ["", Validators.compose([Validators.required])],
    });
    this.registerForm = this.formBuilder.group({
      firstName: ["", Validators.compose([Validators.required])],
      lastName: ["", Validators.compose([Validators.required])],
      ownerPhone: ["", Validators.compose([Validators.required])],
      ownerEmail: ["", Validators.compose([Validators.required])],
      businessName: ["", Validators.compose([Validators.required])],
      businessAlias: [""],
      businessDomain: ["", Validators.compose([Validators.required])],
      businessWebsite: ["", Validators.compose([Validators.required])],
      businessDescription: ["", Validators.compose([Validators.required])],
      addressLine1: ["", Validators.compose([Validators.required])],
      addressLine2: ["", Validators.compose([Validators.required])],
      businessCity: ["", Validators.compose([Validators.required])],
      businessState: ["", Validators.compose([Validators.required])],
      businessCountry: ["", Validators.compose([Validators.required])],
      pincode: ["", Validators.compose([Validators.required])],
    });
    this.checkFormData();

    this.images = [
      { id: "01", image_link: "assets/images/BusinessGrowth-login.png" },
      // { id: '01', image_link: 'assets/images/slider1.jpg' },
      // { id: '02', image_link: 'assets/images/slider2.jpg' },
      // { id: '03', image_link: 'assets/images/slider1.jpg' },
      // { id: '04', image_link: 'assets/images/slider2.jpg' }
    ];

    // this.stateList = [
    //   { name: 'Tamil Nadu', cities: ['Chennai', 'Cuddalore', 'Chidambaram', 'Madurai'] },
    //   { name: 'Karnataka', cities: ['Bangalore'] },
    //   { name: 'Andhra Pradesh', cities: ['Nellore'] },
    // ];
    // this.onboarding_stateList = [
    //   { name: 'Tamil Nadu', cities: ['Chennai', 'Cuddalore', 'Chidambaram', 'Madurai'] },
    //   { name: 'Karnataka', cities: ['Bangalore'] },
    //   { name: 'Andhra Pradesh', cities: ['Nellore'] },
    // ];
  }

  getCountryList() {
    let res: Response;
    // this.HttpService.getRequestAdmin({ customApiUrl: `${this.BASE_URL.BASE_API_URL_ADMIN}/${this.BASE_URL.COUNTRY_API}` })
    this.HttpService.getRequestAdmin({
      customApiUrl: `${this.BASE_URL.COUNTRY_API}`,
    }).subscribe((data) => {
      res = data;
      if (res.code === 200) {
        this.countryList = res.data["countries"];
        console.log("this.countryList", this.countryList);
      }
      // console.log(this.products);
    });
  }
  getZceppaProducts() {
    let res: Response;
    this.HttpService.getRequestAdmin({
      customApiUrl: this.BASE_URL.VIEW_ZCEPPA_PRODUCTS,
    }).subscribe((data) => {
      res = data;
      if (res.code === 200) {
        const products: any = res.data["product_list"];
        this.products = products;
        this.selectedProduct = [
          ...Array<boolean>(this.products.length).fill(false),
        ];
        // this.products = products.reduce((acc, cv) => {
        //   return [...acc, { product_name: cv.product_name, product_id: cv.product_id }]
        // }, [])
      }
      // console.log(this.products);
    });
  }

  onProductSelect(product_id, idx) {
    console.log(product_id);
    if (this.selectedProduct[idx] === true) {
      this.selectedProduct[idx] = false;
      this.product_array.splice(this.product_array.indexOf(product_id), 1);
    } else {
      this.selectedProduct[idx] = true;
      this.product_array.push(product_id);
    }
    console.log(this.product_array);
  }

  onboardingStateList() {
    let res: Response;
    this.HttpService.getRequestAdmin({
      customApiUrl: this.BASE_URL.VIEW_ONBOARDING_STATES,
    }).subscribe((data) => {
      res = data;
      if (res.code === 200) {
        const stateList = res.data["states"];
        this.stateList = stateList;
        this.onboarding_stateList = stateList;
      }
    });
  }

  changeCountry(country_id) {
    let res: Response;
    this.HttpService.getRequestAdmin({
      customApiUrl: this.BASE_URL.STATES_API(country_id),
    }).subscribe((data) => {
      res = data;
      if (res.code === 200) {
        const stateList = res.data["states"];
        this.stateList = stateList;
        this.onboarding_stateList = stateList;
        console.log(this.onboarding_stateList);
      }
    });
    // this.cities = this.stateList.find(con => con.name == count).cities;
  }
  changeState(state_id) {
    let res: Response;
    this.HttpService.getRequestAdmin({
      customApiUrl: this.BASE_URL.VIEW_ONBOARDING_CITIES(state_id),
    }).subscribe((data) => {
      res = data;
      if (res.code === 200) {
        // console.log(res.data);
        this.cities = res.data["cities"];
        this.onboarding_cities = res.data["cities"];
        setTimeout(() => {
          this.business_address_details_form.patchValue({
            businessCity: "",
          }),
            0;
        });

        setTimeout(() => {
          this.registerForm2.patchValue({
            outlet_city: "",
            outlet_state: "",
          }),
            0;
        });
      }
    });
    // this.cities = this.stateList.find(con => con.name == count).cities;
  }

  onBoardingChangeState(state_id) {
    let res: Response;
    this.HttpService.getRequestAdmin({
      customApiUrl: this.BASE_URL.VIEW_ONBOARDING_CITIES(state_id),
    }).subscribe((data) => {
      res = data;
      if (res.code === 200) {
        // console.log(res.data);
        this.onboarding_cities = res.data["cities"];
        setTimeout(() => {
          this.registerForm2.patchValue({
            outlet_city: "",
          }),
            0;
        });
      }
    });
    // this.onboarding_cities = this.onboarding_stateList.find(con => con.name == count).cities;
  }
  /**
   *  Check form2 data validation
   */
  checkFormData() {
    this.registerForm2 = this.formBuilder.group({
      manager_first_name:
        this.has_manager === true
          ? ["", Validators.compose([Validators.required])]
          : [""],
      manager_last_name:
        this.has_manager === true
          ? ["", Validators.compose([Validators.required])]
          : [""],
      manager_phone:
        this.has_manager === true
          ? ["", Validators.compose([Validators.required])]
          : [""],
      manager_email:
        this.has_manager === true
          ? ["", Validators.compose([Validators.required])]
          : [""],
      manager_country_code: ["91"],
      outlet_location_name: ["", Validators.compose([Validators.required])],
      // 'outlet_internal_name': ['', Validators.compose([Validators.required])],
      outlet_address_line1:
        this.address_as_same === false
          ? ["", Validators.compose([Validators.required])]
          : [""],
      outlet_address_line2:
        this.address_as_same === false
          ? ["", Validators.compose([Validators.required])]
          : [""],
      outlet_pincode:
        this.address_as_same === false
          ? ["", Validators.compose([Validators.required])]
          : [""],
      outlet_phone_number:
        this.address_as_same === false
          ? ["", Validators.compose([Validators.required])]
          : [""],
      outlet_country:
        this.address_as_same === false
          ? ["", Validators.compose([Validators.required])]
          : [""],
      outlet_city:
        this.address_as_same === false
          ? ["", Validators.compose([Validators.required])]
          : [""],
      outlet_state:
        this.address_as_same === false
          ? ["", Validators.compose([Validators.required])]
          : [""],
      // 'products': ['', Validators.compose([Validators.required])]
    });
  }

  checkHasManagerAddressData() {
    this.registerForm2 = this.formBuilder.group({
      manager_first_name:
        this.has_manager === true
          ? [
              this.onBoardingFormData2.manager_first_name.value,
              Validators.compose([Validators.required]),
            ]
          : [this.onBoardingFormData2.manager_first_name.value],
      manager_last_name:
        this.has_manager === true
          ? [
              this.onBoardingFormData2.manager_last_name.value,
              Validators.compose([Validators.required]),
            ]
          : [this.onBoardingFormData2.manager_last_name.value],
      manager_phone:
        this.has_manager === true
          ? [
              this.onBoardingFormData2.manager_phone.value,
              Validators.compose([Validators.required]),
            ]
          : [this.onBoardingFormData2.manager_phone.value],
      manager_email:
        this.has_manager === true
          ? [
              this.onBoardingFormData2.manager_email.value,
              Validators.compose([Validators.required]),
            ]
          : [this.onBoardingFormData2.manager_email.value],
      manager_country_code: ["91"],
      outlet_location_name: [
        this.registerForm2.controls.outlet_location_name.value,
        Validators.compose([Validators.required]),
      ],
      // 'outlet_internal_name': [this.registerForm2.controls.outlet_internal_name.value, Validators.compose([Validators.required])],
      outlet_address_line1:
        this.address_as_same === false
          ? [
              this.onBoardingFormData2.outlet_address_line1.value,
              Validators.compose([Validators.required]),
            ]
          : [this.onBoardingFormData2.outlet_address_line1.value],
      outlet_address_line2:
        this.address_as_same === false
          ? [
              this.onBoardingFormData2.outlet_address_line2.value,
              Validators.compose([Validators.required]),
            ]
          : [this.onBoardingFormData2.outlet_address_line2.value],
      outlet_pincode:
        this.address_as_same === false
          ? [
              this.onBoardingFormData2.outlet_pincode.value,
              Validators.compose([Validators.required]),
            ]
          : [this.onBoardingFormData2.outlet_pincode.value],
      outlet_phone_number:
        this.address_as_same === false
          ? [
              this.onBoardingFormData2.outlet_phone_number.value,
              Validators.compose([Validators.required]),
            ]
          : [this.onBoardingFormData2.outlet_phone_number.value],
      outlet_country:
        this.address_as_same === false
          ? [
              this.onBoardingFormData2.outlet_country.value == ""
                ? this.businessAddressDetailsData.businessCountry.value
                : this.onBoardingFormData2.outlet_country.value,
              Validators.compose([Validators.required]),
            ]
          : [this.onBoardingFormData2.outlet_country.value],
      outlet_city:
        this.address_as_same === false
          ? [
              this.onBoardingFormData2.outlet_city.value == ""
                ? this.businessAddressDetailsData.businessCity.value
                : this.onBoardingFormData2.outlet_city.value,
              Validators.compose([Validators.required]),
            ]
          : [this.onBoardingFormData2.outlet_city.value],
      outlet_state:
        this.address_as_same === false
          ? [
              this.onBoardingFormData2.outlet_state.value == ""
                ? this.businessAddressDetailsData.businessState.value
                : this.onBoardingFormData2.outlet_state.value,
              Validators.compose([Validators.required]),
            ]
          : [this.onBoardingFormData2.outlet_state.value],
      // 'has_manager': this.address_as_same === false ? [this.address_as_same] : [true],
      // 'address_as_same': this.has_manager === true ? [this.has_manager === true] : [false]
      // 'products': ['', Validators.compose([Validators.required])]
      // 'businessCity': ['', Validators.compose([Validators.required])],
      // 'businessState': ['', Validators.compose([Validators.required])],
      // 'businessCountry': ['', Validators.compose([Validators.required])],
    });
  }

  setCountryDetailsByDefault() {
    // this.onBoardingFormData2.
  }

  clicknext() {
    if (this.address_sec === false) {
      this.address_sec = true;
      setTimeout(() => {
        this.business_address_details_form.patchValue({
          businessState:
            this.business_address_details_form.controls.businessState.value,
          businessCity:
            this.business_address_details_form.controls.businessCity.value,
          businessCountry:
            this.business_address_details_form.controls.businessCountry.value,
        });
      });
    } else {
      this.address_sec = false;
      //console.log(this.business_detail_form.controls.businessDomain.value);
      setTimeout(() => {
        this.business_detail_form.patchValue({
          businessDomain:
            this.business_detail_form.controls.businessDomain.value,
        });
      }, 500);
    }
  }

  clickNextPrevious() {
    if (this.firstSetp === true) {
      this.firstSetp = false;
      this.address_sec = true;
      setTimeout(() => {
        this.business_address_details_form.patchValue({
          businessState:
            this.business_address_details_form.controls.businessState.value,
          businessCity:
            this.business_address_details_form.controls.businessCity.value,
          businessCountry:
            this.business_address_details_form.controls.businessCountry.value,
        });
      });
    }
  }

  /**
   * Get all data controls form business details form
   *
   * @readonly
   * @memberof BusinessOnboardingComponent
   */
  get businessDetailsData() {
    return this.business_detail_form.controls;
  }

  /**
   * Get all data controls form business address details form
   *
   * @readonly
   * @memberof BusinessOnboardingComponent
   */
  get businessAddressDetailsData() {
    return this.business_address_details_form.controls;
  }

  /**
   * Business details form details check
   *
   * @param {FormGroup} Form
   * @memberof BusinessOnboardingComponent
   */
  onBusinessDetailsSubmit(_Form: FormGroup) {
    this.business_details_submit = false;
    // stop here if form is invalid
    if (this.business_detail_form.invalid) {
      return;
    }
    this.business_details_submit = true;
    this.address_sec = true;
    setTimeout(() => {
      this.business_address_details_form.patchValue({
        businessState:
          this.business_address_details_form.controls.businessState.value,
        businessCity:
          this.business_address_details_form.controls.businessCity.value,
        businessCountry:
          this.business_address_details_form.controls.businessCountry.value,
      });
    });
  }

  /**
   * Business address details form check
   *
   * @param {FormGroup} Form
   * @memberof BusinessOnboardingComponent
   */
  onBusinessAddressDetailsSubmit(Form: FormGroup) {
    let res: Response;
    this.business_address_details_submit = false;
    if (this.business_address_details_form.invalid) {
      return;
    }
    this.business_address_details_submit = true;
    this.business_form_details = {
      owner_first_name: this.businessDetailsData.firstName.value,
      owner_last_name: this.businessDetailsData.lastName.value,
      owner_country_code: "91",
      owner_phone: this.businessDetailsData.ownerPhone.value,
      owner_email: this.businessDetailsData.ownerEmail.value,
      business_name: this.businessDetailsData.businessName.value,
      business_alias: this.businessDetailsData.businessAlias.value,
      business_domain: this.businessDetailsData.businessDomain.value,
      business_website: this.businessDetailsData.businessWebsite.value,
      business_description: Form.controls.businessDescription.value,
      business_address_line_1: Form.controls.addressLine1.value,
      business_address_line_2: Form.controls.addressLine2.value,
      business_city: Form.controls.businessCity.value,
      business_state: Form.controls.businessState.value,
      business_country: Form.controls.businessCountry.value,
      business_pincode: Form.controls.pincode.value,
    };
    this.firstSetp = true;
    setTimeout(() => {
      // console.log(this.registerForm2.controls.outlet_state.value);
      if (this.address_as_same == false) {
        // console.log("check if on submit 2");
        // this.registerForm2.patchValue({
        //   'outlet_country': this.registerForm2.controls.outlet_country.value,
        //   'outlet_state': this.registerForm2.controls.outlet_state.value,
        //   'outlet_city': this.registerForm2.controls.outlet_city.value,
        // });
        // this.registerForm2.patchValue({
        //   'outlet_country': Form.controls.businessCountry.value,
        //   'outlet_state': Form.controls.businessState.value,
        //   'outlet_city': Form.controls.businessCity.value,
        // });
        // this.registerForm2.patchValue({
        //   'outlet_country': '',
        //   'outlet_state': '',
        //   'outlet_city': '',
        // });
        this.checkHasManagerAddressData();
      }
    });
    // console.log(data_json); return;
    // const data_service = this.HttpService.putjson(this.BASE_URL.ONBOARDING_CREATE_URL, data_json);
    // data_service.subscribe((data: Response) => {
    //   res = data;
    //   this.createdUserId = res.data['user_id'];
    // }, error => {
    //   this.toastrService.error(error.error.message);
    // }, () => {
    //   if (res.code === 200 || res.code === 201) {
    //     this.firstSetp = true;
    //   } else {
    //     this.toastrService.error(res.data['message']);
    //   }
    // });
  }

  /**
   * Check Address details
   *
   * @param {*} event
   * @memberof BusinessOnboardingComponent
   */
  checkAddressDetails(event) {
    this.address_as_same = event.target.checked;
    this.checkHasManagerAddressData();
  }

  /**
   * Check Manager details
   *
   * @param {*} event
   * @memberof BusinessOnboardingComponent
   */
  checkManagerDetails(event) {
    this.has_manager = event.target.checked;
    this.checkHasManagerAddressData();
  }

  /**
   * Get all data from business onboarding detail and validating the form data
   *
   * @readonly
   * @memberof BusinessOnboardingComponent
   */
  get onBoardingFormData() {
    return this.registerForm.controls;
  }

  /**
   * Get all data from business onboarding details for manager form data
   *
   * @readonly
   * @memenberof BusinessOnboardingComponent
   */
  get onBoardingFormData2() {
    return this.registerForm2.controls;
  }

  /**
   * Business details email vaidation
   *
   * @memberof ClientsComponent
   */
  checkmail() {
    this.emailnotvalid = true;
    if (
      this.businessDetailsData.ownerEmail.value.match(
        /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,}$/
      )
    ) {
      this.emailnotvalid = true;
    } else {
      this.emailnotvalid = false;
    }
  }

  /**
   * Outlet details email vaidation
   *
   * @memberof ClientsComponent
   */
  checkmailoutlet() {
    this.emailnotvalid = true;
    if (
      this.onBoardingFormData2.manager_email.value.match(
        /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,}$/
      )
    ) {
      this.emailnotvalid = true;
    } else {
      this.emailnotvalid = false;
    }
  }

  /**
   * Business on boarding create and outlet create
   *
   * @param {FormGroup} Form
   * @returns
   * @memberof BusinessOnboardingComponent
   */
  onSubmit(Form: FormGroup) {
    let res: Response;
    this.submitted = false;
    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }
    this.submitted = true;
    const data_json = {
      owner_first_name: Form.controls.firstName.value,
      owner_last_name: Form.controls.lastName.value,
      owner_country_code: "91",
      owner_phone: Form.controls.ownerPhone.value,
      owner_email: Form.controls.ownerEmail.value,
      business_name: Form.controls.businessName.value,
      business_alias: Form.controls.businessAlias.value,
      business_domain: Form.controls.businessDomain.value,
      business_website: Form.controls.businessWebsite.value,
      business_description: Form.controls.businessDescription.value,
      business_address_line_1: Form.controls.addressLine1.value,
      business_address_line_2: Form.controls.addressLine2.value,
      business_city: Form.controls.businessCity.value,
      business_state: Form.controls.businessState.value,
      business_country: Form.controls.businessCountry.value,
      business_pincode: Form.controls.pincode.value,
    };
    // console.log(data_json); return;
    const data_service = this.HttpService.putjson(
      this.BASE_URL.ONBOARDING_CREATE_URL,
      data_json
    );
    data_service.subscribe(
      (data: Response) => {
        res = data;
        this.createdUserId = res.data["user_id"];
        this.createdBusinessId = res.data["business_id"];
      },
      (error) => {
        this.toastrService.error(error.error.message);
      },
      () => {
        if (res.code === 200 || res.code === 201) {
          this.firstSetp = true;
        } else {
          this.toastrService.error(res.data["message"]);
        }
      }
    );
  }
  /**
   * Business on boarding create and outlet create
   *
   * @param {FormGroup} Form
   * @returns
   * @memberof BusinessOnboardingComponent
   */
  onSubmitSecond(Form: FormGroup) {
    console.log(Form);
    this.submitted = false;
    // stop here if form is invalid
    if (this.registerForm2.invalid || this.product_array.length == 0) {
      if (this.product_array.length == 0)
        this.toastrService.error(`Please choose atleast one or more products.`);
      return;
    }
    this.submitted = true;
    let data_json_outlet: any;
    let res: Response;
    const data_service = this.HttpService.putjson(
      this.BASE_URL.ONBOARDING_CREATE_URL,
      this.business_form_details
    );
    data_service.subscribe(
      (data: Response) => {
        res = data;
        // console.log(res);
        this.createdUserId = res.data["user_id"];
        this.createdBusinessId = res.data["business_id"];
      },
      (error) => {
        this.toastrService.error(error.error.message);
      },
      () => {
        if (res.code === 200 || res.code === 201) {
          if (this.address_as_same === true && this.has_manager === true) {
            data_json_outlet = {
              address_same: this.address_as_same,
              has_manager: this.has_manager,
              user_id: this.createdUserId,
              business_id: this.createdBusinessId,
              manager_first_name: Form.controls.manager_first_name.value,
              manager_last_name: Form.controls.manager_last_name.value,
              manager_phone: Form.controls.manager_phone.value,
              manager_country_code: "91",
              manager_email: Form.controls.manager_email.value,
              outlet_location: Form.controls.outlet_location_name.value,
              outlet_internal_name: Form.controls.outlet_location_name.value,
              // 'outlet_internal_name': this.businessDetailsData.businessName.value + ' ' + Form.controls.outlet_location_name.value,
            };
          } else if (
            this.address_as_same === true &&
            this.has_manager === false
          ) {
            data_json_outlet = {
              address_same: this.address_as_same,
              has_manager: this.has_manager,
              user_id: this.createdUserId,
              business_id: this.createdBusinessId,
              outlet_location: Form.controls.outlet_location_name.value,
              outlet_internal_name: Form.controls.outlet_location_name.value,
              // 'outlet_internal_name': this.businessDetailsData.businessName.value + ' ' + Form.controls.outlet_location_name.value,
            };
          } else if (
            this.address_as_same === false &&
            this.has_manager === true
          ) {
            data_json_outlet = {
              address_same: this.address_as_same,
              has_manager: this.has_manager,
              user_id: this.createdUserId,
              business_id: this.createdBusinessId,
              manager_first_name: Form.controls.manager_first_name.value,
              manager_last_name: Form.controls.manager_last_name.value,
              manager_phone: Form.controls.manager_phone.value,
              manager_country_code: "91",
              manager_email: Form.controls.manager_email.value,
              outlet_location: Form.controls.outlet_location_name.value,
              outlet_internal_name: Form.controls.outlet_location_name.value,
              // 'outlet_internal_name': this.businessDetailsData.businessName.value + ' ' + Form.controls.outlet_location_name.value,
              outlet_address_line_1: Form.controls.outlet_address_line1.value,
              outlet_address_line_2: Form.controls.outlet_address_line2.value,
              outlet_pincode: Form.controls.outlet_pincode.value,
              outlet_phone_number: Form.controls.outlet_phone_number.value,
              outlet_country: Form.controls.outlet_country.value,
              outlet_city: Form.controls.outlet_city.value,
              outlet_state: Form.controls.outlet_state.value,
            };
          } else {
            data_json_outlet = {
              address_same: this.address_as_same,
              has_manager: this.has_manager,
              user_id: this.createdUserId,
              business_id: this.createdBusinessId,
              outlet_location: Form.controls.outlet_location_name.value,
              outlet_internal_name: Form.controls.outlet_location_name.value,
              // 'outlet_internal_name': this.businessDetailsData.businessName.value + ' ' + Form.controls.outlet_location_name.value,
              outlet_address_line_1: Form.controls.outlet_address_line1.value,
              outlet_address_line_2: Form.controls.outlet_address_line2.value,
              outlet_pincode: Form.controls.outlet_pincode.value,
              outlet_phone_number: Form.controls.outlet_phone_number.value,
              outlet_country: Form.controls.outlet_country.value,
              outlet_city: Form.controls.outlet_city.value,
              outlet_state: Form.controls.outlet_state.value,
            };
          }
          let resp: Response;
          const data_service_outlet = this.HttpService.putjson(
            this.BASE_URL.OUTLET_CREATE_MAIN_URL,
            data_json_outlet
          );
          data_service_outlet.subscribe(
            (data: Response) => {
              resp = data;
              // console.log(resp);
              this.outlet_id = resp.data["outlet_id"];
            },
            (error) => {
              this.toastrService.error(error.error.message);
            },
            () => {
              if (res.code === 200 || res.code === 201) {
                this.HttpService.postRequestAdmin({
                  customApiUrl: this.BASE_URL.CREATE_ZCEPPA_PRODUCT(
                    this.outlet_id
                  ),
                  data: {
                    product: this.product_array,
                  },
                }).subscribe((data) => {
                  res = data;
                  if (res.code === 200) {
                  }
                });

                this.isExistingOwner = resp.data["is_owner_exists"] == 1;

                this.firstSetp = false;
                this.openBackDrop();
                if (this.isExistingOwner) {
                  setTimeout(() => {
                    this.modalService.dismissAll();
                    this.router.navigate(["../signin"]);
                  }, 2000);
                } else {
                  const data_services = this.HttpService.getOTP(
                    this.businessDetailsData.ownerPhone.value
                  );
                  this.commonservice.setFirstView(true);
                  data_services.subscribe(
                    (data: Response) => {
                      res = data;
                    },
                    (error) => {
                      this.toastrService.error(error.error.message);
                    },
                    () => {}
                  );

                  setTimeout(() => {
                    this.modalService.dismissAll();
                    this.commonservice.showOtpScreen(
                      this.businessDetailsData.ownerPhone.value
                    );
                    this.commonservice.setFirstView(true);
                    this.router.navigate(["../signin"]);
                  }, 2000);
                }

                this.business_detail_form.patchValue({
                  firstName: "",
                  lastName: "",
                  // 'ownerPhone': '',
                  ownerEmail: "",
                  businessName: "",
                  businessAlias: "",
                  businessDomain: "",
                  businessWebsite: "",
                });
                this.business_address_details_form.setValue({
                  addressLine1: "",
                  addressLine2: "",
                  businessCity: "",
                  businessState: "",
                  businessCountry: "",
                  pincode: "",
                  businessDescription: "",
                });
                this.registerForm2.setValue({
                  manager_first_name: "",
                  manager_last_name: "",
                  manager_phone: "",
                  manager_country_code: "91",
                  manager_email: "",
                  outlet_location_name: "",
                  // 'outlet_internal_name': '',
                  outlet_address_line1: "",
                  outlet_address_line2: "",
                  outlet_pincode: "",
                  outlet_phone_number: "",
                  outlet_country: "",
                  outlet_city: "",
                  outlet_state: "",
                  // 'products': '',
                });
              } else {
                this.toastrService.error(res.data["message"]);
              }
            }
          );
        } else {
          this.toastrService.error(res.data["message"]);
        }
      }
    );
  }

  /**
   * Open success popup model
   *
   * @memberof BusinessOnboardingComponent
   */
  openBackDrop() {
    this.modalService.open(this.accessSuccessModal, {
      backdropClass: "light-blue-backdrop",
    });
  }

  closeModel() {
    this.modalService.dismissAll();
    this.router.navigate(["../signin"]);
  }

  /***
   *
   */
  websiteValidation() {
    this.websitenotvalid = true;
    if (this.businessDetailsData.businessWebsite.value !== "") {
      if (
        this.businessDetailsData.businessWebsite.value.match(
          /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/
        )
      ) {
        this.websitenotvalid = true;
      } else {
        this.websitenotvalid = false;
      }
    }
  }
}
